<div class="modal-editions" cdkTrapFocus cdkTrapFocusAutoCapture>
  <div *ngIf="isLoading; else editionsModal">
    <div class="d-flex justify-content-center pt-5">
      <div class="spinner-container" role="status" aria-live="polite">
        <div class="spinner-border text-primary" data-automation-id="custom-showcase-spinner">
          <span class="sr-only" translate>Loading...</span>
        </div>
      </div>
    </div>
  </div>
  <ng-template #editionsModal>
    <div  class="d-flex justify-content-between mb-6">
      <div class="d-flex">
        <button class="btn mr-2" *ngIf="showFullMarcRecord" (click)="$event.preventDefault(); toggleFullMark()">
          <fa-icon [icon]="closeFullMarc"></fa-icon>
        </button>
        <h4 class="modal-title font-weight-bold"
            [tippy]="title"
            id="drawer-items-title"
            data-automation-id="drawer-items-title">
          {{ title }}
        </h4>
      </div>
      <button
        class="close-btn p-0 h-auto"
        (click)="onDismissActiveModal()"
        [attr.aria-label]="'closeItemsDrawer' | translate"
        data-automation-id="close-drawer-btn">
        <span class="icon-close"></span>
      </button>
    </div>

    <ng-container *ngIf="fullMarcRecordAvailable">
      <!-- Show Mark Button  -->
      <div class="d-flex  mb-3" [ngClass]="showFullMarcRecord ? 'justify-content-between' : 'justify-content-end'">
        <ng-container *ngIf="showFullMarcRecord">
          <h4 class="marc-container-title">{{ 'editionDetailsFullMarc' | translate }}</h4>
        </ng-container>
        <button class="n-text btn-marc-record width-auto" *ngIf="!showFullMarcRecord" (click)="$event.preventDefault(); toggleFullMark()">
          {{ 'editionDetailsFullMarcRecord' | translate }}
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="showFullMarcRecord" class="d-flex justify-content-between mb-6">
      <div class="marc-container" id="marc-container" data-automation-id="marc-container"></div>
    </ng-container>
    <ng-container *ngIf="!showFullMarcRecord">
      <div class="edition-items" *ngIf="edition; else noData">
        <!-- Editions List  -->
        <ng-container *ngFor="let field of generalView">
          <app-edition-sidebar-item [field]="field"></app-edition-sidebar-item>
        </ng-container>

        <ng-container *ngFor="let field of languagesView">
          <app-edition-sidebar-item [field]="field"></app-edition-sidebar-item>
        </ng-container>

        <ng-container *ngFor="let field of accessibilityView">
          <app-edition-sidebar-item [field]="field"></app-edition-sidebar-item>
        </ng-container>

        <ng-container *ngFor="let field of seriesView">
          <app-edition-sidebar-item [field]="field"></app-edition-sidebar-item>
        </ng-container>

        <ng-container *ngFor="let field of swissCollectionsView">
          <app-edition-sidebar-item [field]="field"></app-edition-sidebar-item>
        </ng-container>

        <ng-container *ngFor="let field of subjectsView">
          <app-edition-sidebar-item [field]="field"></app-edition-sidebar-item>
        </ng-container>

        <ng-container *ngFor="let field of noteGeneralView">
          <app-edition-sidebar-item [field]="field"></app-edition-sidebar-item>
        </ng-container>

        <ng-container *ngFor="let field of contributorsView">
          <app-edition-sidebar-item [field]="field"></app-edition-sidebar-item>
        </ng-container>

        <ng-container *ngFor="let field of controlNumbersView">
          <app-edition-sidebar-item [field]="field"></app-edition-sidebar-item>
        </ng-container>
      </div>
      <ng-template #noData>
        <p class="no-data">No edition data.</p>
      </ng-template>
    </ng-container>
  </ng-template>
</div>
